import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AboutComponent} from '../about/about.component';
import {RouterModule} from '@angular/router';
import { SkillsComponent } from '../skills/skills.component';
import { ContactsComponent } from '../contacts/contacts.component';

const routes = [
  {path: '', redirectTo: '/about', pathMatch: 'full'},
  {path: 'about', component: AboutComponent},
  {path: 'skills', component: SkillsComponent},
  {path: 'contacts', component: ContactsComponent}
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {useHash: true})
  ],
  declarations: []
})
export class RoutersModule {

}



// WEBPACK FOOTER //
// E:/Java/ResumeAngular/resume/src/app/router/routers.module.ts